<template>
  <div class="skills">
    <div class="container">
      <div class="row">
        <div class="col s12 m6">
          <div class="title">Skills and experience.</div>
          <p>
            I have been working as a freelancer for {{ years }} years now, i
            have done remote work for agencies, consulted for strtups,
            maintained several projects, collaborated with clients to build
            diffferent types of web apps.
          </p>

          <p>
            I create successful responsive websites that are fast, easy to use
            and built with best practices. The main area of my expertise is
            <span>Front-end development</span>. HTML, CSS and JS are the tools
            that i use in developing small and medium web apps for my clients. I
            prefer using either Vue or React for modern Single page Progresive
            Web Apps (PWAs) to ensure a smooth user experience.
          </p>
          <p>
            I'm also a <span>Back-end developer</span> where I use Nodejs and Go
            as my primary language to build fast, secure, reliable and scalable
            cloud solutions.For example: ecommerce plartforms, portals, Content
            Management Systems, Customer Relations Management Systems e.t.c
          </p>

          <router-link to="/technologies" class="link"
            >You can preview all the technologies i use.
          </router-link>
        </div>
        <div class="col s12 m6 my">
          <img
            src="@/assets/vectors/skills.svg"
            class="img-responsive swing"
            style="animation-delay: 3s"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, onMounted } from "vue";
export default {
  setup() {
    const begining = ref("01/01/2018");
    const years = ref("");
    onMounted(() => {
      const time = new Date() - new Date(begining.value);
      years.value = new Date(time).getFullYear() - 1970;
    });

    return {
      years,
    };
  },
};
</script>

<style scoped>
.skills {
  min-height: 100%;
  /* margin-top: auto; */
  align-items: center;
  justify-content: center;
  margin-top: 75px;
  margin-bottom: 75px;
}
.title {
  font-size: 48px;
  font-weight: 600;
}
.link {
  text-decoration: none;
  font-weight: 600;
  color: #765cd1;
  position: relative;
  display: inline-block;
  background: linear-gradient(to right, #765cd1, midnightblue 50%, #765cd1 50%);
  overflow: hidden;
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-size: 200% 100%;
  background-position: 100%;
  transition: background-position 275ms ease;
}
.link:hover {
  background-position: 0 100%;
}
.img-responsive {
  width: 100%;
  height: auto;
}
span {
  border-bottom: 2px dotted #765cd1;
  font-weight: 600;
}
@media only screen and (max-width: 601px) {
  .my {
    margin-top: 30px;
    margin-bottom: 30px;
  }
}

@-webkit-keyframes swinging {
  0% {
    /* -webkit-transform: (8deg); */
    -webkit-transform: translateY(20py);
  }
  50% {
    /* -webkit-transform: rotate(-4deg); */
    -webkit-transform: translateY(0px);
  }
  100% {
    /* -webkit-transform: rotate(8deg); */
    -webkit-transform: translateY(20px);
  }
}

@keyframes swinging {
  0% {
    /* -webkit-transform: (8deg); */
    -webkit-transform: translateY(20px);
  }
  50% {
    /* -webkit-transform: rotate(-4deg); */
    -webkit-transform: translateY(0px);
  }
  100% {
    /* -webkit-transform: rotate(8deg); */
    -webkit-transform: translateY(20px);
  }
}

.swing {
  -webkit-transform-origin: 50% 0;
  transform-origin: 50% 0;
  -webkit-animation: swinging 3.5s ease-in-out forwards infinite;
  animation-delay: 5s;
  animation: swinging 3.5s ease-in-out forwards infinite;
}
</style>
